import { NotificationCustomerService } from './../../services/notification.customer.service';
import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-notification-widget',
  standalone: false,
  templateUrl: './notification-widget.component.html',
  styleUrls: ['./notification-widget.component.scss']

})
export class NotificationWidgetComponent implements OnInit {
  private toastMessage = '';
  private toastType = 'info';
  notificationFlag: boolean = false;
  toggleMenuFlag = false;
  clickHandler: any;

  notifications: any[] = [];
  clicedOut: boolean;
  constructor(private toastr: ToastrService, private ns: NotificationCustomerService) {}

  ngOnInit() {
    this.ns.listNotifications().subscribe((res: any) => {
      if (res.case === 1) {
        this.notifications = res.notification;
        this.notifications.forEach(notification => {
          notification.notificationLink = this.notificationLinkGenerator(notification);
        });
      } else {
        this.notifications = [];
      }
    });
  }

  notificationLinkGenerator(notification: any): string {
    let finalLink = '';
    if (notification.requestId) {
      return (finalLink = `/home/requests/view-request/${notification.requestId}`);
    }
    if (notification.orderId) {
      // return (finalLink = `/home/orders/view/${notification.orderId}`);
    }
    if (notification.carId) {
      return (finalLink = '/home/profile/');
    }
    return finalLink;
  }
  clickFunction() {
    console.log('click out!');
    window.removeEventListener('click', this.clickHandler, true);
    this.closeNotification();
    this.clicedOut = true;
  }
  toggleNotification() {
    if (this.clicedOut) {
      this.clicedOut = false;
      return;
    }
    this.notificationFlag = true;
    this.clickHandler = this.clickFunction.bind(this);
    window.addEventListener('click', this.clickHandler, true);
  }
  closeNotification() {
    this.notificationFlag = false;
  }
}